module.exports = __webpack_public_path__ + "static/media/bgtop-system-03-1.3bfcfbe7.jpg";